import styled from 'styled-components';

export default styled.div`
  margin-top: ${({ margin }) => margin || '3rem'};
  display: grid;
  grid-row-gap: 1rem;
`;
